import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
  ComposedChart, Line, Legend
} from 'recharts';
import { dropOffChartData, funnelCompareSteps, funnelSteps } from '../../../mocks/funnel';

const CustomTooltip = ({ active, payload, label }: any) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white border border-border rounded-xl p-3 shadow-hover text-[12px]">
      <p className="font-semibold text-charcoal-500 mb-1 text-[11px]">{label}</p>
      {payload.map((p: any) => (
        <p key={p.name} style={{ color: p.color }} className="font-medium">{p.name}: {p.value}{typeof p.value === 'number' && p.name.includes('%') ? '' : typeof p.value === 'number' && p.value < 100 ? '%' : ''}</p>
      ))}
    </div>
  );
};

export function DropOffChart() {
  return (
    <div className="bg-white rounded-2xl shadow-card p-6">
      <div className="mb-5">
        <h3 className="text-[15px] font-semibold text-charcoal-600">Adımlar Arası Kayıp Oranı</h3>
        <p className="text-[12px] text-charcoal-300 mt-0.5">Her geçişteki düşüş yüzdesi</p>
      </div>
      <ResponsiveContainer width="100%" height={200}>
        <BarChart data={dropOffChartData} margin={{ top: 5, right: 5, left: -20, bottom: 0 }}>
          <defs>
            <linearGradient id="dropGrad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#E57373" />
              <stop offset="100%" stopColor="#FFCDD2" />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#F0EDE8" vertical={false} />
          <XAxis dataKey="step" tick={{ fontSize: 9, fill: '#A0A0A0' }} axisLine={false} tickLine={false} />
          <YAxis tick={{ fontSize: 11, fill: '#A0A0A0' }} axisLine={false} tickLine={false} unit="%" />
          <Tooltip content={<CustomTooltip />} cursor={{ fill: '#FAF8F4' }} />
          <Bar dataKey="dropOff" name="Kayıp %" fill="url(#dropGrad)" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export function CompareChart() {
  const data = funnelCompareSteps.map((s, i) => ({
    step: funnelSteps[i]?.label.split(' ')[0] || s.id,
    'Bu Dönem': s.current,
    'Önceki Dönem': s.previous,
  }));

  return (
    <div className="bg-white rounded-2xl shadow-card p-6">
      <div className="mb-5">
        <h3 className="text-[15px] font-semibold text-charcoal-600">Dönem Karşılaştırması</h3>
        <p className="text-[12px] text-charcoal-300 mt-0.5">Bu dönem vs önceki dönem</p>
      </div>
      <ResponsiveContainer width="100%" height={200}>
        <ComposedChart data={data} margin={{ top: 5, right: 5, left: -20, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#F0EDE8" vertical={false} />
          <XAxis dataKey="step" tick={{ fontSize: 9, fill: '#A0A0A0' }} axisLine={false} tickLine={false} />
          <YAxis tick={{ fontSize: 11, fill: '#A0A0A0' }} axisLine={false} tickLine={false} />
          <Tooltip content={<CustomTooltip />} />
          <Legend iconType="circle" iconSize={8} wrapperStyle={{ fontSize: 11 }} />
          <Bar dataKey="Bu Dönem" fill="#D4AF37" radius={[3, 3, 0, 0]} opacity={0.85} />
          <Bar dataKey="Önceki Dönem" fill="#C8C8C8" radius={[3, 3, 0, 0]} opacity={0.7} />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
}
